import { modelHelperModule } from './model-helper';
import { checkPrivilege } from '../utils/privilege-utils';

export const candidateModelModule = angular
  .module('Q.models.candidate', [modelHelperModule])

  .factory('Candidate', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'Candidate',
      endpoint: 'candidates',

      serialize: ModelHelper.serializeWithUiPrefs,
      deserialize: ModelHelper.deserializeWithUiPrefs,

      relations: {
        hasMany: {
          Assessment: {
            localField: 'assessments',
          },
          AssessmentResult: {
            localField: 'assessmentResults',
            foreignKey: 'candidateId',
          },
          Solution: {
            localField: 'solutions',
            foreignKey: 'candidateId',
          },
          TeamCandidate: {
            localField: 'teamCandidates',
            foreignKey: 'candidateId',
          },
        },
      },

      methods: {
        loginType: 'candidate',
        hasRole(/* role */) {
          return true;
        },
        hasFeature(feature) {
          return !!(this.features && this.features[feature]);
        },
        hasPrivilege(privilege, value) {
          return checkPrivilege(this, privilege, value);
        },
        isTeamMember(teamId = false) {
          const teamIds = this.teamIds;
          return (
            teamIds &&
            teamIds.length > 0 &&
            (!teamId || teamIds.indexOf(teamId) > -1)
          );
        },
        isActive() {
          return this.state === 'active';
        },
      },

      meta: {
        saveExcludes: ['assessments', 'assessmentResults', 'solutions'],
        actionEndpoints: {
          forget: { method: 'POST', track: true },
        },
      },
    });
  });
